import { Icon } from 'components/Icon/Icon';
import styles from './Banner.module.scss'
import { faFileCircleInfo, IconDefinition } from '@fortawesome/pro-solid-svg-icons'

type Props = {
    title: string
    message: string
    icon: IconDefinition
};

export const Banner = ({title, message, icon}: Props) => {   
    return (
        <div className={styles.container}>
        <div className={styles.header}><Icon icon={icon} ></Icon>{title}</div>
        <div className={styles.content}>{message}</div>
    </div>
    );
};

export default Banner;